import styles from './InfoCard.module.css'

export default function InfoCard ({ title, children, links }) {
  return (
    <article className={styles.infoCard}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.content}>
        {children}
      </div>
      {links && links.length > 0 && (
        <nav className={styles.links}>
          {links.map((link, index) => (
            <a
              key={index}
              href={link.href}
              target='_blank'
              rel='noopener noreferrer'
              className={styles.link}
              aria-label={link.ariaLabel}
            >
              {link.text}
            </a>
          ))}
        </nav>
      )}
    </article>
  )
}
